import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import Loader from "components/shared/loader";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";

import { handleErrMsg } from "helpers/functions";
import { Col } from "react-bootstrap";
import "styles/applications.css";
import { editWebhook } from "store/webhooks/actions";

const EditAlertsSwitch = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    loading,
    error,
    user: { webHooksAlertsToMail },
  } = useSelector((state) => state.authentication);

  useEffect(() => {
    if (Object.keys(error)?.length > 0) {
      toastErrorMessage(formatMessage({ id: handleErrMsg(error) }), locale);
    }
  }, [error, formatMessage, locale, navigate]);

  if (loading) return <Loader />;

  return (
    <div className="applications form-group card">
      <Col as="label" lg={6} xs={12} className="position-relative">
        <div>
          <h5 className="mb-2 mt-2">
            <FormattedMessage id="changeWebhookMail" />
          </h5>
        </div>
        <div className="switcher">
          <input
            type="checkbox"
            className="switcher-input"
            defaultChecked={webHooksAlertsToMail}
            onChange={({ target: { checked } }) => {
              dispatch(
                editWebhook({
                  webHooksAlertsToMail: checked,
                })
              );
            }}
          />
          <div className="knobs"></div>
          <div className="layer"></div>
        </div>
      </Col>
    </div>
  );
};

export default EditAlertsSwitch;
